var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:`${
    !_vm.$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
  }`,attrs:{"id":"materialpro"}},[(this.$store.state.blockPrint)?_c('div',{staticClass:"block-print"},[_c('v-img',{attrs:{"contain":"","src":require("@/assets/imgs/logos/logo_preto.png")}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }